module.exports = __webpack_public_path__ + "static/media/pin_point_of_interest.42c874d0.svg";